import { createSlice } from '@reduxjs/toolkit';
import { getFeaturedArticlesList } from '../actions/featuredArticlesActions';
import { initBlogListType, blogListDefaultCases } from '../../blogs/slices/lists/blogListReducerUtils';

// import {
//   blogListDefaultCases as articleListCases,
//   initBlogListType,
// } from './blogListReducerUtils';
// import {  getFeaturedArticlesList } from '../../actions/featuredArticlesActions';

const initialState = initBlogListType() as BlogListStateType;

const articleFeaturedListSlice = createSlice({
  name: 'articleFeaturedListSlice',
  initialState,
  reducers: {
    resetShuffledBlogListState: () => initialState,
  },
  extraReducers: builder => {
    blogListDefaultCases(builder, getFeaturedArticlesList);
  },
});

export const { resetShuffledBlogListState } = articleFeaturedListSlice.actions;
export default articleFeaturedListSlice.reducer;
